module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAGQCAYAAABvWArbAAAAP0lEQVQ4je3PMQrAMABC0a/3v2zX0mCXNkOgc6C4PARd5DqPGKCU8luS8SbAQhiCQRgJE56kZTfbbP9RSvnkBsWcEAZRWcgqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/ui/images/ui-bg_glass_55_fbf9ee_1x400.png
// module id = 240
// module chunks = 0